<template>
  <v-navigation-drawer
    :value="menuOpen"
    @input="(newValue) => $store.commit('MainTemplate/setMenuOpen', newValue)"
    color="grey lighten-5"
    app
  >
    <v-list-item class="px-2 py-5">
      <v-list-item-content>
        <v-list-item-title class="d-flex justify-center">
          <router-link :to="{ name: 'home' }">
            <img src="/img/logo-ePublic.png" class="mb-5" />
          </router-link>
        </v-list-item-title>

        <v-list-item-subtitle class="d-flex justify-center">
          <e-ano-selector class="" />
          <!-- <e-franquia-selector class="ml-2" /> -->
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list dense>
      <v-list-group
        v-for="item in menu.items.filter(
          (item) =>
            item.exibir && item.children.filter((child) => $can(child.permissions)).length > 0
        )"
        :key="item.title"
        v-model="item.active"
        no-action
        :append-icon="item.children && item.children.length > 0 ? undefined : ''"
        :prepend-icon="item.icon"
        @click="() => (item.to ? $router.push(item.to) : undefined)"
      >
        <template v-slot:activator>
          <!-- <v-list-item
                :to="item.to || undefined"
                link
              > -->
          <v-list-item-content>
            <v-list-item-title v-text="item.title" />
          </v-list-item-content>
          <!-- </v-list-item
              > -->
        </template>
        <v-list-item
          v-for="child in item.children"
          v-show="$can(child.permissions)"
          :key="child.title"
          :to="child.to"
          :href="child.href"
          :target="child.target"
        >
          <v-divider v-if="child.type === 'spacer'" />
          <v-list-item-content v-if="child.type !== 'spacer'">
            <v-list-item-title v-text="child.title" />
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <!-- </v-list-group> -->
    <!-- </v-list> -->
    <template v-slot:append>
      <e-situacao-caixa v-if="exibirFinanceiro" />
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import EAnoSelector from "@/Pages/Templates/components/EAnoSelector.vue";
import ESituacaoCaixa from "@/Pages/Templates/components/ESituacaoCaixa.vue";

const exibirFinanceiro = process.env.VUE_APP_ATIVAR_FINANCEIRO === "true";
export default {
  name: "MainTemplate",
  components: {
    EAnoSelector,
    ESituacaoCaixa,
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("MainTemplate", ["menuOpen"]),
    menu() {
      return {
        items: [
          {
            icon: "mdi mdi-home",
            title: "Início",
            exibir: true,
            children: [
              {
                title: "Ir para Início",
                to:
                  (this.user ? this.user.roleName : "") === "professor"
                    ? {
                        name: "acessoProfessor.home",
                      }
                    : {
                        name:
                          (this.user ? this.user.roleName : "") === "prof-auxiliar"
                            ? "acessoProfessor.home"
                            : "home",
                      },
                icon: "",
              },
              {
                title: "Ir para notifiq",
                to: {
                  name: "notifiq.index",
                },
                permissions: ["notifiq.load"],
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-book",
            title: "Agenda",
            exibir: (this.user ? this.user.roleName : "") === "aluno",
            children: [
              {
                title: "Ir para Agendas",
                to: {
                  name: "agenda.aluno",
                },
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-alert",
            title: "Avisos",
            exibir: true,
            permissions: ["alunos.detalhes"],
            children: [
              // {
              //   title: "Meus avisos",
              //   to: {
              //     name: "avisos.portal",
              //   },
              //   icon: "",
              // },
              {
                title: "Ir para Avisos",
                to: {
                  name:
                    (this.user ? this.user.roleName : "") === "aluno"
                      ? "avisos.portal"
                      : "avisos.index",
                },
                permissions: ["avisos.*", "avisos.listar", "alunos.detalhes"],
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-account-school",
            title: "Matrículas",
            exibir: true,
            children: [
              {
                title: "Ver Matrículas",
                to: { name: "matriculas" },
                permissions: ["matriculas.matricular", "matriculas.*"],
                icon: "",
              },
              // { title: "Adicionar matricula", to: "#", icon: "" },
              {
                title: "Ver Alunos",
                to: { name: "alunos" },
                permissions: ["alunos.criarAluno", "alunos.*"],
                icon: "",
              },
              {
                title: "Pesquisa avançada",
                to: { name: "alunos-pesquisa-avancada" },
                permissions: ["alunos.criarAluno", "alunos.*"],
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-school",
            title: "Turmas",
            exibir: true,
            children: [
              {
                title: "Ver turmas",
                to: { name: "turmas" },
                permissions: ["turmas.criarTurma", "turmas.*"],
                icon: "",
              },
              {
                title: "Gestão de anos",
                to: { name: "series" },
                icon: "fa fa-bookmark",
                permissions: ["series.*", "series.criar"],
              },
              {
                title: "Gestão de disciplinas",
                to: { name: "disciplinas" },
                icon: "fa fa-bookmark",
                permissions: ["disciplinas.*", "disciplinas.criarDisciplina"],
              },
            ],
          },
          {
            icon: "mdi mdi-note-text",
            title: "Listar Planos",
            exibir: (this.user ? this.user.roleName : "") !== "professor",
            children: [
              {
                title: "Planos Anuais",
                to: { name: "gestoesDeAulas.planosAnuais" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
              {
                title: "Planos Bimestrais",
                to: { name: "gestoesDeAulas.planos" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
              {
                title: "Planos Infantis Bimestrais",
                to: { name: "gestoesDeAulas.planosInfantil" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
              // {
              //   title: "Planos infantis anuais",
              //   to: { name: "gestoesDeAulas.planosAnuaisInfantil" },
              //   icon: "",
              //   permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              // },
            ],
          },
          {
            icon: "mdi mdi-human-male-board-poll",
            title: "Diário online",
            exibir: true,
            children: [
              {
                title: "Listar todos",
                to: { name: "gestoesDeAulas" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
              {
                title: "Gestão geral",
                to: { name: "gestoesDeAulas.geral" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.gestoesGeral"],
              },
              {
                title: "Agendas",
                to: { name: "agenda.index" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.listar"],
              },
            ],
          },
          // aqui
          {
            icon: "mdi mdi-human-male-board",
            title: "Diário de Auxiliares",
            exibir: true,
            children: [
              {
                title: "Listar todos",
                to: { name: "gestoesDeAulasAuxiliares" },
                icon: "",
                permissions: [
                  "gestoesDeAulasAuxiliares.*",
                  "gestoesDeAulasAuxiliares.criar",
                  "gestoesDeAulasAuxiliares.listar",
                ],
              },
            ],
          },
          {
            icon: "mdi mdi-human-male-board-poll",
            title: "Diário AEE",
            exibir: true,
            children: [
              {
                title: "Listar todos",
                to: { name: "educacaoInclusiva" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
            ],
          },
          {
            icon: "mdi mdi-file",
            title: "Relatórios",
            exibir: true,
            children: [
              {
                title: "Ver todos",
                to: { name: `relatorios`, params: { franquiaId: this.user?.franquia.id } },
                icon: "",
                permissions: ["relatorios.*"],
              },
            ],
          },
          {
            icon: "mdi mdi-account-switch",
            title: "Usuários",
            exibir: true,
            children: [
              {
                title: "Ver Professores",
                to: { name: "professores" },
                icon: "fa fa-user-tie",
                permissions: ["users.*"],
              },
              {
                title: "Bloqueios/Liberações",
                to: { name: "usuarios.listaDeUsuariosParaBloquearLiberar" },
                icon: "fa fa-bookmark",
                permissions: ["users.*"],
              },
              {
                title: "Outros",
                to: { name: "usuarios" },
                icon: "fa fa-bookmark",
                permissions: ["users.*"],
              },
            ],
          },
          {
            icon: "fa fa-money",
            title: "Financeiro",
            exibir: exibirFinanceiro,
            children: [
              {
                title: "Mensalidades",
                to: { name: "mensalidades" },
                permissions: "financeiro.baixarParcela",
                icon: "",
              },
              {
                title: "Gestão de Caixas",
                to: { name: "caixas" },
                permissions: "caixas.abrir",
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-account-network",
            title: "Administração",
            exibir: true,
            children: [
              {
                title: "Dashboard",
                to: { name: "admin" },
                permissions: ["franquias.*", "franquias.criarFranquia"],
                icon: "",
              },
              {
                title: "Sala de Situação",
                to: { name: "salaDeSituacao" },
                permissions: ["franquias.*", "franquias.criarFranquia"],
                icon: "",
              },
              {
                title: "Escolas",
                to: { name: "franquias" },
                permissions: ["franquias.*", "franquias.criarFranquia"],
                icon: "",
              },
              {
                title: "Bolsa Família",
                to: { name: "bolsa-familia" },
                permissions: ["bolsaFamilia.*"],
                icon: "",
              },
              {
                title: "Calculadora FUNDEB",
                to: { name: "fundeb.calculadora" },
                permissions: ["franquias.*"],
                exibir: this.user.roleName === "admin" || this.user.roleName === "super-admin",
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-help",
            title: "Ajuda e tutorial",
            exibir: true,
            children: [
              {
                title: "Tutoriais",
                href: "https://epublic.tawk.help/",
                target: "_blank",
              },
              // {
              //   title: "Fale conosco",
              //   href: "https://tawk.to/caju",
              //   target: "_blank",
              // },
            ],
          },
        ],
        width: "250px",
      };
    },
  },
  mounted() {
    // this.$Tawk.$setOnLoadFunction(() => this.$Tawk.$showWidget());
  },
  data() {
    return {
      selectedItem: 0,
      openAtualizarSenhaModal: false,
      openSelecionarFranquiaModal: false,
      exibirFinanceiro,
    };
  },
  methods: {
    toggleMenu() {
      this.$store.commit("MainTemplate/setMenuOpen", !this.menuOpen);
    },
  },
};
</script>
